import { render } from "./ManagementSection.vue?vue&type=template&id=9ab3e648&scoped=true"
import script from "./ManagementSection.vue?vue&type=script&lang=js"
export * from "./ManagementSection.vue?vue&type=script&lang=js"

import "./ManagementSection.vue?vue&type=style&index=0&id=9ab3e648&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab3e648"]])

export default __exports__